import React from 'react'

interface ProfileData {
  first_name: string
  last_name: string
}
interface Props {
  profile: ProfileData
  className?: string
}

export const Avatar = ({ profile, className = '' }: Props) => {
  return (
    <div
      className={` h-[2.5rem] w-[2.5rem] bg-white rounded-full flex justify-center items-center ${className}`}
    >
      <div className={`text-primary-main uppercase text-xs font-medium ${className}`}>
        {profile?.first_name?.[0] || 'U'}
        {profile?.last_name?.[0]}
      </div>
    </div>
  )
}
